<!--直播间推荐  -->
<template>
  <div :class="['recommendCourse',{'new':type === 'new'}]">
    <template v-if="recommendList.length"
      ><div v-for="(item, keys) in recommendList" :key="keys">
        <CombinationCard v-if="item.setType === 1" :item="item" @click.native="goback(item)" />
        <HotCourseCard v-else :key="keys" :item="item" @click.native="goback(item)" /></div
    ></template>
    <!-- <template v-if="recommendList.length">
      <HotCourseCard v-for="(item, keys) in recommendList" :key="keys" :item="item" />
    </template> -->
    <template v-else>
      <div class="norecommend">
        <img src="../../../assets/img/live/norecommend.png" alt="" />
        <p>暂时还没有推荐课程哦～</p>
      </div>
    </template>
  </div>
</template>
<script>
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import { reqliveDetails, reqliveRecommended } from '../../../api/live/index';
import { reqCombinationlist } from '@/api/combination';
import HotCourseCard from '../../../components/hotCourseCard/hotCourseCard.vue';
import { gioPlatform } from '@/utils/tools';
export default {
  data() {
    return {
      productList:[],
      recommendList: [], // 课程信息
    };
  },
 props:[
   'courseVOList',
   'type'
 ],
  components: {
    HotCourseCard,
    CombinationCard,
  },
  watach:{
    courseVOList() {
      this.productList = this.courseVOList;
      this.getRecommendedList()
    }
  },

  computed: {},

  mounted() {
    if(this.type === 'new') {   //新版推荐
      this.productList = this.courseVOList;
      this.getRecommendedList()
    } else {
      this.getCourseIds();
    }
  },

  created() {},
  methods: {
    // 根据直播间id查询推荐的课程id
    async getCourseIds() {
      // this.productList = this.RecommendCourse.recommendContentVOList || [];
      // 直播间 和 回放
      let liveId = this.$route.query.liveId || this.$route.params.resourceId;
      const res = await reqliveDetails(liveId);
      this.productList = res.data.recommendContentVOList||[];
      this.getRecommendedList();
    },
    // 根据课程id查询推荐的课程信息
    async getRecommendedList() {
      const allProductIds = [];
      const allPackageIds = [];
      this.productList.forEach(child => {
        if (child.recommendType === 0) {
          allProductIds.push(child.productId);
        } else {
          allPackageIds.push(child.productId);
        }
      });
      const endPoint = this.$root.$data.isApp ? 2 : 4;
      const res = allProductIds.length ? await reqliveRecommended(allProductIds) : {};
      const res1 = allPackageIds.length ? await reqCombinationlist(0, endPoint, allPackageIds) : {};
      const resCourse = this.resetCourse(res.data || []);
      const resPackage = this.resetCoursePackage(res1.data || []);
      const allCourse = [];
      this.productList.forEach(child => {
        const findRes = [...resCourse, ...resPackage].find(course => {
          const id = child.recommendType === 0 ? course.productId : course.packageId;
          return id === child.productId;
        });
        // eslint-disable-next-line no-unused-expressions
        findRes && allCourse.push(findRes);
      });
      this.recommendList = allCourse;
    },
    resetCourse(recommendList) {
      recommendList.forEach(item => {
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map(teacher => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount &&
          productDiscountRespVO?.couponDiscount &&
          item.sellPrice > 0 &&
          !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (Number(productDiscountRespVO.discountMinPrice) +
              Number(productDiscountRespVO.discountAmount)).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return recommendList;
    },
    // 套餐卡片
    resetCoursePackage(majorCourseList) {
      majorCourseList.forEach(item => {
        const { packageDiscountRespVO } = item;
        Object.assign(item, {
          isArk: 1,
          setType: 1,
          salesVolume: Number(item.actualSales) + Number(item.initialSales),
          isCouponDiscount: packageDiscountRespVO?.isCouponDiscount, // 优惠券
        });
        if (
          packageDiscountRespVO?.isCouponDiscount &&
          item.sellPrice > 0 &&
          !packageDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
          });
        }
        if (packageDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: packageDiscountRespVO?.promotionLabel,
            originalPrice: item.sellPrice,
            sellPrice: packageDiscountRespVO.payPrice,
            acvitityShowTime: packageDiscountRespVO?.promotionShowTime,
            acvitityStartTime: packageDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: packageDiscountRespVO?.promotionEndTime,
          });
        }
      });
      return majorCourseList;
    },
    goback(item) {
      sessionStorage.setItem('back', true);
        this.gioEvent(item)
    },
     gioEvent(item) {
       const {setType} = item;
      const courseName = item.name;
      // 点击广告
      // eslint-disable-next-line
        gio('track', 'adClick_event', {
        adPosition_var: '直播间推荐课程', // 广告位置
        pageName_var: '直播间', // 页面名称
        adSequence_var: null, // 广告序号
        adId_var: null, // 广告ID
        adName_var: courseName, // 广告名称
        linesBusiness_var: '考研', // 业务线
        jumpType_var: setType === 1 ? '套餐' : '产品', // 跳转类型
        platform_var: gioPlatform(),
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.recommendCourse {
  height: 100%;
  padding: 40px 40px 100px 40px;
  overflow: auto;
  .norecommend {
    width: 70%;
    margin:  100px auto 0;
    padding: 0 20px;
    img {
      width: 100%;
      height: 208px;
    }
    p {
      width: 100%;
      color: #ccc;
      font-size: 25px;
      text-align: center;
    }
  }
}
.new {
  overflow: unset;
}
</style>
